/** Directory of experts with profiles and task counts. */
import { Link } from 'react-router-dom'
import { api } from '@/api/client'
import { useAsync } from '@/components/useAsync'
import { REVIEW_STAGES } from '@/lib/stages'
import { Avatar, ProfileHover } from '@/components/Avatar'
import { profileAreas, type SmeSummary } from '@/lib/types'

export default function EngSmes() {
  const stages = REVIEW_STAGES
  const { data, error, loading } = useAsync(() => api.get<{ smes: SmeSummary[] }>('/eng/smes'))
  if (loading) return <p className="muted">Loading…</p>
  if (error || !data) return <div className="note err">{error}</div>

  return (
    <div>
      <div className="page-head"><div><h1>Experts</h1><div className="meta">Click an expert to see their profile, and a total to list their tasks.</div></div></div>
      <div className="table-wrap expert-table"><table aria-label="Experts and task counts">
        <colgroup><col className="identity-column" /><col className="programs-column" />{stages.map(s => <col key={s.stage} className="stage-column" />)}<col className="total-column" /></colgroup>
        <thead><tr><th scope="col">Expert</th><th scope="col">Area and programs</th>{stages.map((s) => <th scope="col" key={s.stage} className="num">{s.label}</th>)}<th scope="col" className="num">Total</th></tr></thead>
        <tbody>
          {data.smes.map((u) => (
            <tr key={u.user_id}>
              <td className="expert-identity"><ProfileHover user={u}><span className="expert-cell"><Avatar avatar={u.avatar} name={u.name || u.email} size={36} /><span><strong>{u.name || u.email}</strong>{u.peer_reviewer && <span className="expert-reviewer-badge">Peer reviewer</span>}{u.name && <span className="expert-email muted small">{u.email}</span>}</span></span></ProfileHover></td>
              <td className="expert-programs small" data-label="Areas and programs">{profileAreas(u).join(', ') || <span className="muted">—</span>}{u.programs?.length ? <div className="muted small">{u.programs.join(', ')}</div> : null}</td>
              {stages.map((s) => <td key={s.stage} className="num expert-stage" data-label={s.label}><span className="cell-label">{s.label}</span><span>{u.task_counts[String(s.stage)] || <span className="muted">0</span>}</span></td>)}
              <td className="num expert-total"><span className="cell-label">Total tasks</span><Link aria-label={`View all ${u.task_total} tasks for ${u.name || u.email}`} to={`/eng/tasks?sme_id=${u.user_id}`}>{u.task_total}</Link></td>

            </tr>
          ))}
          {data.smes.length === 0 && <tr><td colSpan={10} className="table-empty muted">No experts have signed up yet.</td></tr>}
        </tbody>
      </table></div>
      <p className="muted small" style={{ marginTop: '.75rem' }}>Stages: {stages.map((s) => `${s.num} ${s.label}`).join(' · ')}</p>
    </div>
  )
}
